/** Single user-facing copy when a chart has nothing to show (empty, error, or filtered empty). */
export const CHART_NO_DATA_FOR_ARTIST = 'No data available for this artist';
